import { generateAssets } from '@/shared/responsiveAssetsLoader';
import { GameAssets } from '@/types/assets';

const assetsDir = 'games/TheDecoder/';
const gameAssets: GameAssets = {
  audio: {
    theme: 'theme.mp3',
    gamePlay: 'gameplay.mp3',
    voiceDemoIntroGreeting: 'demo_intro_greeting.mp3',
    voiceDemoFlashInstruction: 'demo_flash_instruction.mp3',
    voiceDemoNextSymbolPrompt: 'demo_next_symbol_prompt.mp3',
    voiceDemoIncorrectSymbol: 'demo_incorrect_symbol.mp3',
    voiceDemoContinueDecoding: 'demo_continue_decoding.mp3',
    voiceDemoCodeDiscovered: 'demo_code_discovered.mp3',
    voiceDemoArrangeInstruction: 'demo_arrange_instruction.mp3',
    voiceDemoCompletionMidGame: 'demo_completion_mid_game.mp3',
    voiceDemoCompletionInitial: 'demo_completion_initial.mp3',
    voiceSucceed: 'in-game-by-jove-you-ve-got-it.mp3',
    voiceFailDescription: 'in-game-that-s-not-quite-right.mp3',
  },
  images: {
    splash: 'splash.webp',
    background: 'background.webp',
    seeingGlass: 'seeing_glass.webp',
    symbol0: 'symbol_0.webp',
    symbol1: 'symbol_1.webp',
    symbol2: 'symbol_2.webp',
    symbol3: 'symbol_3.webp',
    symbol4: 'symbol_4.webp',
    symbol5: 'symbol_5.webp',
    symbol6: 'symbol_6.webp',
    symbol7: 'symbol_7.webp',
    symbol8: 'symbol_8.webp',
    symbol9: 'symbol_9.webp',
    symbol10: 'symbol_10.webp',
    symbol11: 'symbol_11.webp',
    symbol12: 'symbol_12.webp',
    symbol13: 'symbol_13.webp',
    symbol14: 'symbol_14.webp',
  },
};

export default generateAssets(assetsDir, gameAssets);
